import {NgModule} from '@angular/core';
import {WorkerService} from './worker/worker.service';
import {ClusterService} from './map/cluster/cluster.service';

import {AreaDrawerService} from './map/drawer/area/area-drawer.service';
import {ClusterDrawerService} from './map/drawer/cluster/cluster-drawer.service';
import {RouteDrawerService} from './map/drawer/route/route-drawer.service';
import {EventDrawerService} from './map/drawer/event/event-drawer.service';

import {MapService} from './map/map/map.service';
import {VehicleService} from './vehicle/vehicle.service';
import {MappingService} from './mapping/mapping.service';
import {PanelNavigationService} from './navigation/panel-navigation.service';
import {WebAccessService} from './web.access/web-access.service';
import {ConfigurationService} from './configuration/configuration.service';
import {RemoteDataService} from './remote.data/remote-data.service';
import {NotificationService} from './notification/notification.service';
import {DriverService} from './driver/driver.service';
import {ScrollService} from './scroll/scroll.service';
import {DataListService} from './data.list/data-list.service';
import {DataListMouseScrollDirective} from './data.list/data-list-mouse-scroll.directive';
import {PopupRendererService} from './map/renderer/popup-renderer.service';
import {PopupDrawerService} from './map/drawer/popup/popup-drawer.service';
import {IconService} from './icon/icon.service';
import {RouteService} from './route/route.service';
import {TachoService} from './tacho/tacho.service';
import {VehicleFullListService} from './full.list/vehicle-full-list.service';
import {HttpProgressInterceptor} from './http.interceptor/http-progress-interceptor.service';
import {ProgressService} from './progress/progress.service';
import {EventService} from './event/event.service';
import {AreaService} from './area/area.service';
import {MapConfigService} from './map/config/map-config.service';
import {CountryCodeService} from './country.code/country-code.service';
import {MapControlService} from './map/control/map-control.serivce';
import {CacheService} from './cache/cache.service';
import {AuthenticationService} from '@shared/services/authentication/authentication.service';
import { DatePipe } from '@angular/common';

/**
 * Modul glowny wszystkich serwisow
 */
@NgModule({
    imports: [],
    declarations: [
        DataListMouseScrollDirective
    ],
    exports: [
        DataListMouseScrollDirective
    ],
    providers: [
        WorkerService,
        ClusterService,
        MapService,
        VehicleService,
        AreaDrawerService,
        ClusterDrawerService,
        RouteDrawerService,
        EventDrawerService,
        MappingService,
        PanelNavigationService,
        WebAccessService,
        ConfigurationService,
        RemoteDataService,
        NotificationService,
        DriverService,
        DataListService,
        ScrollService,
        PopupRendererService,
        PopupDrawerService,
        IconService,
        RouteService,
        TachoService,
        VehicleFullListService,
        HttpProgressInterceptor,
        ProgressService,
        EventService,
        AreaService,
        MapConfigService,
        CountryCodeService,
        MapControlService,
        CacheService,
        AuthenticationService,
        DatePipe,
      ]
})
export class ServicesModule {
}
